@if (showActions()) {
@if (mode() === 'menu') {
<p-menu #actionsMenuOnly [model]="menuItems()" [popup]="true" [appendTo]="'body'" />
<i class="yllw-quote-toolbar__utility-btn pi pi-cog" [pTooltip]="'QUOTE.DETAIL.MORE_ACTIONS' | translate"
    tooltipPosition="bottom" (click)="actionsMenuOnly.toggle($event)"></i>
}

@if (mode() === 'primary') {
@if (showSplitButton()) {
<p-splitButton
    [label]="primaryLabel()"
    [icon]="primaryIcon()"
    [severity]="primarySeverity()"
    [buttonDisabled]="isPrimaryDisabled()"
    [menuButtonDisabled]="false"
    [model]="splitMenuItems()"
    [pTooltip]="disabledTooltip()"
    tooltipPosition="bottom"
    size="small"
    styleClass="quote-actions__split"
    (onClick)="onPrimaryClick()" />
} @else if (showPrimaryBtn()) {
<p-button [label]="primaryLabel()" [icon]="primaryIcon()" [severity]="primarySeverity()"
    [disabled]="isPrimaryDisabled()" [pTooltip]="disabledTooltip()" tooltipPosition="bottom" size="small"
    (onClick)="onPrimaryClick()" />
}
}
}